import React, { useEffect, useState } from "react";
import * as wk from "../utils/wkCommon";
import { toPinyinSync, capitalizePinyin } from "../utils/pinyinUtil";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function QrPusat({ umat, autoFetch = false }) {
  const [data, setData] = useState(umat || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
    //console.log("QrPusat", umat)
  useEffect(() => {
    if (!autoFetch || !umat.documentId) return;

    let mounted = true;

    (async () => {
      try {
        setLoading(true);
        const url = `${API_URL}/api/umats/${encodeURIComponent(umat.documentId)}?populate=*`;
        const resp = await wk.apiFetch(url);
        const d = resp?.data || resp;

        if (mounted) setData(d);
      } catch (e) {
        if (mounted) setError(e.message);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => (mounted = false);
  }, [umat.documentId, autoFetch]);

  if (loading) return <div style={{ textAlign: "center" }}>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!data) return <div style={{ textAlign: "center" }}>No data</div>;

  const chinese =
    data?.chineseName
      ? data.chineseName + " " + capitalizePinyin(toPinyinSync(data.chineseName))
      : "-";

  const displayName = data?.fullName || data?.nickName || "Unknown";
  const qrData = data?.tsfyUmatID || "-";

  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=360x360&data=${encodeURIComponent(qrData)}`;

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "1rem" }}>
      <div
        style={{
          width: "100%",
          maxWidth: "28rem",
          textAlign: "center",
          borderRadius: "0.75rem",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          background: "#fff",
          padding: "0.75rem",
        }}
      >
        <div
          style={{
            background: "#0e6c63",
            color: "#fff",
            padding: "1rem",
            borderTopLeftRadius: "0.625rem",
            borderTopRightRadius: "0.625rem",
            fontSize: "1.5rem",
          }}
        >
          天聖佛院
        </div>

        <div
          style={{
            padding: "1rem",
            borderLeft: "0.75rem solid #0e6c63",
            borderRight: "0.75rem solid #0e6c63",
          }}
        >
          <img
            src={qrUrl}
            alt="qr"
            style={{ width: "100%", maxWidth: "22rem" }}
          />
          <div
            style={{
              marginTop: "0.75rem",
              fontSize: "1.25rem",
              color: "#0e6c63",
              fontWeight: 600,
            }}
          >
            {qrData}
          </div>
        </div>

        <div
          style={{
            background: "#0e6c63",
            color: "#fff",
            padding: "0.875rem",
            borderBottomLeftRadius: "0.625rem",
            borderBottomRightRadius: "0.625rem",
          }}
        >
          <div style={{ fontWeight: 700 }}>{chinese}</div>
          <div style={{ fontSize: "0.85rem", marginTop: "0.25rem" }}>
            {displayName}
          </div>
        </div>
      </div>
    </div>
  );
}